<template>
  <div id="app" class="container-fluid">
    <div class="nav-img">
      <div>
        <a href="https://www.senatelive.com/" target="_blank">
          <b-img
            :src="`${images.SenateLive_Logo2}`"
          >
          </b-img
        ></a>
      </div>
      <div class="BoxCast-Link">
        <span>Powered by</span>
        <a href="https://www.boxcast.com" target="_blank"
          ><b-img
            alt="BoxCast"
            src="https://cdn2.hubspot.net/hub/484866/file-2483746126-png/Logos/NewBoxCastLogo.png?t=1473431021465"
            style="height: 14px; margin-top: -4px"
        /></a>
      </div>
      <div class="BGSU-Link">
        <span>Presented by</span>
        <a href="https://www.bgsu.edu/" target="_blank"
          ><b-img
            alt="BGSU Logo"
            :src="`${images.BGSU_Logo}`"
            style="height: 35px; margin-top: -8px; padding-top: 5px"
        /></a>
      </div>
    </div>

    <router-view />
    <div class="bottom-nav">
      <a href="https://www.senatelive.com/" target="_blank">
        <b-img
          :src="`${images.SenateLive_Logo1}`"
        >
        </b-img
      ></a>
      <span></span>
    </div>
  </div>
</template>

<script>
import NavSchools from "@/components/NavSchools";
export default {
  name: "app",
  data() {
    return {
      images: {
        BGSU_Logo: require("./assets/BGSULogo_21-02-01_nmyb5a.png"),
        SenateLive_Logo1: require("./assets/SenateLive_Icon_color_fe390q.png"),
        SenateLive_Logo2: require("./assets/SenateLiveLogo_Color_Hor-01_smtxt3.png"),
      }
    };
  },
  mounted() {},
  methods: {},
  props: ["search"],
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 15px;
}
.nav-img {
  display: flex;
  /* justify-content: space-between; */
  padding: 0 19rem;
  align-items: center;
  margin-bottom: 15px;
}

@media screen and (max-width: 576px){
  .nav-img {
    padding: 0;
    flex-direction: column;
  }

  .nav-img:second-child {
    flex-direction: row;
  }



}


.BoxCast-Link {
  margin-left: 2rem;
  display: flex;
  flex-direction: column;
}

.BGSU-Link {
  margin-left: 2rem;
  display: flex;
  flex-direction: column;
}

.logo {
  min-height: 30%;
  margin-left: 0.5rem;
}
.ellipse,
.jumbotron h1 {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.fixed-16-9 {
  position: relative;
  padding-bottom: 56.25%; /* 16:9 */
  height: 0;
  background: black;
}
.fixed-16-9 > * {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

@media (max-width: 767px) {
  .col-sm-0 {
    display: none;
  }
}

#boxcast-container .boxcast-well {
  /* reset */
  border: none;
  box-shadow: none;
  text-align: left;
  padding: 0;
  margin: 0;

  /* clean */
  margin-top: 15px;
  padding: 15px;
}
.bottom-nav {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #3f3f46;
  padding: 5rem 0;
  border-top: 1px solid #e5e5e5;
  width: 102%;
  margin-left: -1rem;
}
</style>
